module.exports = __webpack_public_path__ + "img/leaderboard-report.f1a5812.png";